module.exports = __webpack_public_path__ + "img/cq3d-banner.0725a90d.png";